<ion-app>
  <div id="system-message" *ngIf="systemMessage != null && systemMessage.length > 1">{{systemMessage}}</div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<app-help-bubble [pageKey]="helpRoute"></app-help-bubble>